import {
  Button,
  DialogOverlay,
  DialogOverlayActions,
  DialogOverlayFooter,
  Select,
  TextField,
  Paragraph,
} from '@fs/zion-ui'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function OwsSaveChangesDialog({ overlay, saveChanges }) {
  const [editType, setEditType] = useState('OTHER')
  const [reasonText, setReasonText] = useState('')
  const { t } = useTranslation()
  const focusElementRef = useRef()

  return (
    <DialogOverlay focusRef={focusElementRef} title={t('ows.edit.heading', 'Edit OWS')} {...overlay}>
      <Paragraph size="sm">{t('ows.edit.message', 'Please fill out the following information')}</Paragraph>
      <Select
        fullwidth="true"
        label="Edit Type"
        value={editType}
        onChange={(e) => setEditType(e.target.value)}
        options={[
          {
            value: 'BIC_OVERRIDE_BECAUSE_NOT_BIC',
            label: t('ctr.editReasonType.BIC_OVERRIDE_BECAUSE_NOT_BIC', 'Override Because not BIC'),
          },
          {
            value: 'BIC_OVERRIDE_BY_FIRST_PRESIDENCY_AUTHORIZATION',
            label: t(
              'ctr.editReasonType.BIC_OVERRIDE_BY_FIRST_PRESIDENCY_AUTHORIZATION',
              'BIC Override by First Presidency Authorization'
            ),
          },
          {
            value: 'BIC_REVERT_BACK_TO_BIC',
            label: t('ctr.editReasonType.BIC_REVERT_BACK_TO_BIC', 'Revert Back to BIC'),
          },
          {
            value: 'CHANGE_CTR_PERSON_TO_MATCH_OWS_PERSON',
            label: t(
              'ctr.editReasonType.CHANGE_CTR_PERSON_TO_MATCH_OWS_PERSON',
              'Change CTR Person to Match OWS Person'
            ),
          },
          {
            value: 'CMIS_TEMPLE_ORDINANCE',
            label: t('ctr.editReasonType.CMIS_TEMPLE_ORDINANCE', 'CMIS Temple Ordinance'),
          },
          { value: 'CHILD', label: t('ctr.editReasonType.CHILD', 'Child') },
          {
            value: 'DESCRIPTION_FOR_A_PROPER_NAME',
            label: t('ctr.editReasonType.DESCRIPTION_FOR_A_PROPER_NAME', 'Description for a Proper Name'),
          },
          {
            value: 'FIRST_PRESIDENCY_DECISION',
            label: t('ctr.editReasonType.FIRST_PRESIDENCY_DECISION', 'First Presidency Decision'),
          },
          {
            value: 'INFERRED_BY_OTHER_ORDINANCE',
            label: t('ctr.editReasonType.INFERRED_BY_OTHER_ORDINANCE', 'Inferred by Other Ordinance'),
          },
          {
            value: 'LEGACY_SYSTEM_CHANGES_APPLIED',
            label: t('ctr.editReasonType.LEGACY_SYSTEM_CHANGES_APPLIED', 'Legacy System Changes Applied'),
          },
          {
            value: 'LEGACY_SYSTEM_VALIDATION_UNCERTAIN',
            label: t('ctr.editReasonType.LEGACY_SYSTEM_VALIDATION_UNCERTAIN', 'Legacy System Validation Uncertain'),
          },
          { value: 'ORS_MODIFIED_LOR', label: t('ctr.editReasonType.ORS_MODIFIED_LOR', 'ORS Modified LOR') },
          {
            value: 'ORIG_PERSON_TO_CURRENT_OWS_PERSON',
            label: t('ctr.editReasonType.ORIG_PERSON_TO_CURRENT_OWS_PERSON', 'Original Person to Current OWS Person'),
          },
          { value: 'OTHER', label: t('ctr.editReasonType.OTHER', 'Other') },
          {
            value: 'PERFORMED_INCORRECTLY',
            label: t('ctr.editReasonType.PERFORMED_INCORRECTLY', 'Performed Incorrectly'),
          },
          { value: 'PROXY_FOR_LIVING', label: t('ctr.editReasonType.PROXY_FOR_LIVING', 'Proxy for Living') },
          {
            value: 'REPRINTED_ON_NEW_REQUEST',
            label: t('ctr.editReasonType.REPRINTED_ON_NEW_REQUEST', 'Reprinted on new Request'),
          },
          {
            value: 'RERECORD_INVALIDATED_ORDINANCE',
            label: t('ctr.editReasonType.RERECORD_INVALIDATED_ORDINANCE', 'Re-record Invalidated Ordinance'),
          },
          {
            value: 'RECORDED_WRONG_PERFORM_DATE_OR_TEMPLE_CODE',
            label: t(
              'ctr.editReasonType.RECORDED_WRONG_PERFORM_DATE_OR_TEMPLE_CODE',
              'Recorded Wrong Perform Date or Temple Code'
            ),
          },
          {
            value: 'SCANNED_ORDINANCE_NOT_PERFORMED',
            label: t('ctr.editReasonType.SCANNED_ORDINANCE_NOT_PERFORMED', 'Scanned Ordinance not Performed'),
          },
          { value: 'STILLBORN', label: t('ctr.editReasonType.STILLBORN', 'Stillborn') },
          { value: 'UNDER_AGE', label: t('ctr.editReasonType.UNDER_AGE', 'Under Age') },
          {
            value: 'UNWORTHY_PROXY_OR_TEMPLE_WORKER',
            label: t('ctr.editReasonType.UNWORTHY_PROXY_OR_TEMPLE_WORKER', 'Unworthy Proxy or Temple Worker'),
          },
          { value: 'WRONG_GENDER', label: t('ctr.editReasonType.WRONG_GENDER', 'Wrong Gender') },
        ]}
      />
      <TextField
        ref={focusElementRef}
        title={t('reason', 'Reason')}
        value={reasonText}
        label={t('reason', 'Reason')}
        placeholder={
          editType === 'OTHER'
            ? t('ctr.dialog.editCtrTextFieldPlaceholder', 'Please provide a reason for your edit')
            : ''
        }
        onChange={(e) => setReasonText(e.target.value)}
        fullwidth="true"
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button onClick={overlay.close}>Cancel</Button>
          <Button
            disabled={editType === 'OTHER' && reasonText === ''}
            onClick={() => saveChanges(reasonText, editType)}
            emphasis="high"
          >
            {t('action.submit', 'Submit')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
